import React from 'react';
import PropTypes from 'prop-types';
import { I18n as I } from 'react-redux-i18n';

import Popconfirm from 'antd/lib/popconfirm';
import Skeleton from 'antd/lib/skeleton';
import Tooltip from 'antd/lib/tooltip';

const colorClassNames = ['blue', 'red', 'green', 'purple'];

const defaults = {
  colorClassName: colorClassNames[0],
  icon: '',
};

class WidgetCounter extends React.Component {
  render() {
    var value =
      this.props.value instanceof Date
        ? this.props.value.toLocaleDateString()
        : this.props.value;

    const { loading } = this.props;

    return (
      <div className={this.props.containerClassName || ''}>
        <Skeleton loading={loading} active avatar>
          <div className="widget-thumb widget-bg-color-white text-uppercase margin-bottom-20 bordered">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <h4 className="widget-thumb-heading portlet-title">
                {this.props.title}
              </h4>
              {this.props.action && !this.props.actionDisabled ? (
                this.props.actionText ? (
                  <Popconfirm
                    placement="bottom"
                    title={this.props.actionText}
                    onConfirm={this.props.action}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Tooltip title={this.props.tooltip}>
                      <button
                        type="button"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                        className={`btn btn-icon-only ${
                          this.props.actionIcon == 'warning'
                            ? 'red'
                            : this.props.colorClassName
                        } btn-outline`}
                      >
                        <i
                          className={
                            this.props.actionIcon
                              ? `fa fa-${this.props.actionIcon}`
                              : 'fa fa-gears'
                          }
                        />
                      </button>
                    </Tooltip>
                  </Popconfirm>
                ) : (
                  <Tooltip title={this.props.tooltip}>
                    <button
                      type="button"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                      className={`btn btn-icon-only ${this.props.colorClassName} btn-outline`}
                      onClick={this.props.action}
                    >
                      <i
                        className={
                          this.props.actionIcon
                            ? `fa fa-${this.props.actionIcon}`
                            : 'fa fa-gears'
                        }
                      />
                    </button>
                  </Tooltip>
                )
              ) : null}
            </div>
            <div className="widget-thumb-wrap">
              <i
                className={`widget-thumb-icon bg-${
                  this.props.colorClassName || defaults.colorClassName
                } fa fa-${this.props.icon}`}
                style={{ fontSize: 30 }}
              />
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div className="widget-thumb-body">
                  <span className="widget-thumb-subtitle">
                    {this.props.subtitle}
                  </span>
                  <span
                    className="widget-thumb-body-stat"
                    data-counter="counterup"
                    data-value={this.props.value}
                  >
                    {this.props.value}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Skeleton>
      </div>
    );
  }
}

WidgetCounter.propTypes = {
  colorClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  icon: PropTypes.string,
  link: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  actionText: PropTypes.string,
  action: PropTypes.func,
  actionIcon: PropTypes.string,
  value: PropTypes.any,
  amount: PropTypes.any,
  tooltip: PropTypes.string,
};

export default WidgetCounter;
